import React from 'react';
import PropTypes from 'prop-types';
import { Layout, Row, Col } from 'antd';
import styled from 'styled-components';
import MainHeader from '../header';
import MainFooter from '../footer';
import MainWrapper from './styles/MainWrapper';

const { Content } = Layout;

const MainLayout = (props) => {
  const { children } = props;
  return (
    <MainWrapper>
      <Layout style={{ minHeight: '100vh' }}>
        <MainHeader {...props} />
        <Content style={{ backgroundColor: '#FFF7F1' }}>
          <Row justify="center">
            <Col xs={24} sm={24} md={22} lg={22} xl={22}>
              <InnerContent>
                {children}
              </InnerContent>
            </Col>
          </Row>
        </Content>
        <MainFooter />
      </Layout>
    </MainWrapper>
  );
};

MainLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  profile: PropTypes.shape({
    isEmpty: PropTypes.bool,
  }),
};

export default MainLayout;

const InnerContent = styled.div`
  background: #fff;
  padding: 24px;
  margin: 0px;
  margin-top: 20px;
`;
